import { motion } from "framer-motion";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { X, Check } from "lucide-react";
import { vpExamples } from "./vpgData";

const VPGExamplesSection = () => {
  return (
    <section className="py-24 px-4">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <Badge className="px-3 py-1 text-sm bg-primary/10 text-primary border-primary/20 mb-4">
              Value Proposition Examples
            </Badge>
            <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-6">
              Generic vs. High-Converting Ad Copy
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              See the difference a strong value proposition makes across
              different industries.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {vpExamples.map((example, index) => (
            <motion.div
              key={example.industry}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Card className="overflow-hidden h-full">
                <CardContent className="p-0">
                  <div className="px-6 py-4 bg-muted/50 border-b border-border">
                    <span className="font-bold text-lg">
                      {example.industry}
                    </span>
                  </div>

                  {/* Generic */}
                  <div className="px-6 py-4 border-b border-border bg-red-50/50">
                    <div className="flex items-start gap-3">
                      <div className="w-6 h-6 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                        <X className="h-3.5 w-3.5 text-red-500" />
                      </div>
                      <div>
                        <p className="text-xs font-semibold text-red-600 uppercase tracking-wider mb-1">
                          Generic
                        </p>
                        <p className="text-red-900 font-medium">
                          {example.generic}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Strong */}
                  <div className="px-6 py-4 border-b border-border bg-green-50/50">
                    <div className="flex items-start gap-3">
                      <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                        <Check className="h-3.5 w-3.5 text-green-600" />
                      </div>
                      <div>
                        <p className="text-xs font-semibold text-green-600 uppercase tracking-wider mb-1">
                          With Upfixe
                        </p>
                        <p className="text-green-900 font-bold">
                          {example.strong}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Explanation */}
                  <div className="px-6 py-4">
                    <p className="text-sm text-muted-foreground">
                      <span className="font-semibold text-foreground">
                        Why it works:{" "}
                      </span>
                      {example.explanation}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VPGExamplesSection;
